import { scheduleInputToInstant } from "@common/utils/adsetSchedule";

/**
 * When true, the guided schedule editor should not allow changing start time.
 * All conditions must hold (AND): campaign is synced to Meta (`external_id`), and server-provided
 * start is strictly before `now`.
 */
export function shouldLockGuidedScheduleStartEdit(params: {
  campaignExternalId: string | undefined | null;
  serverStartAt: string | undefined | null;
  eventIanaTimezone: string;
  /** Injectable for tests; defaults to current instant. */
  now?: Date;
}): boolean {
  const {
    campaignExternalId,
    serverStartAt,
    eventIanaTimezone,
    now = new Date(),
  } = params;

  if (!String(campaignExternalId ?? "").trim()) return false;

  const rawStart = String(serverStartAt ?? "").trim();
  if (!rawStart) return false;

  const tz = String(eventIanaTimezone ?? "").trim() || "UTC";
  const startInstant = scheduleInputToInstant(rawStart, tz);
  if (!startInstant) return false;

  return startInstant.isBefore(now);
}
